/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */ // Translation keys use snake_case

import { RawTranslations } from '@repo/types';

const translations: RawTranslations = {
    // Native membership
    choose_another_card: 'Dewis cerdyn arall',
    use_auto_selection: 'Defnyddio dewis awtomatig',
    split_into_groups: "Rhannu'n grwpiau",
    add_group: 'Ychwanegu grŵp',
    merge_back_to_auto: "Uno'n ôl yn awtomatig",
    remove_group: 'Tynnu grŵp',
    cards: 'cardiau',
    tickets: 'tocynnau',
    remaining_on_auto: "Mae'r gweddill yn cael ei dalu'n awtomatig",
    member_card_not_applicable: 'Ddim yn berthnasol',
    group_label: 'Grŵp',
    have_account_or_member_card: 'Oes gennych chi gyfrif neu gerdyn aelod?',
    member_card_coverage_failed: 'Methwyd defnyddio eich cardiau aelod.',
    retry: 'Rhowch gynnig arall arni',
    your_member_cards: 'Eich cardiau aelod',
    pay_with_money_instead: 'Talu ag arian yn lle hynny',
    member_card_purchased: "Pwrcas wedi'i gwblhau",
    start_date: 'Dyddiad cychwyn',
    my_page: 'Fy nhudalen',
    password: 'Cyfrinair',
    forgot_password: "Wedi anghofio'ch cyfrinair?",
    member_login_subtitle: 'Sign in to your membership account',
    member_signup_subtitle: 'Create your membership account',
    register: 'Sign up',
    create_account: 'Create account',
    become_member: 'Become a member',
    confirm_password: 'Confirm password',
    need_help: 'Need help?',
    and: 'and',
    passwords_do_not_match: 'Passwords do not match',
    password_too_short: 'Password must be at least 8 characters',
    invalid_phone_format: 'Enter a valid phone number (e.g. +4791234567)',
    email_already_registered: 'This email is already registered',
    registration_failed: 'Registration failed. Please try again.',
    forgot_password_email_sent:
        "Os yw'r cyfeiriad e-bost hwnnw wedi'i gofrestru, byddwch yn derbyn dolen ailosod cyn bo hir.",
    wrong_email_or_password: 'E-bost neu gyfrinair anghywir',
    member_session_expired: 'Mae eich sesiwn wedi dod i ben. Mewngofnodwch eto.',
    show_password: 'Dangos cyfrinair',
    hide_password: 'Cuddio cyfrinair',
    show_cancellation_policy: 'Dangos Polisi Canslo',
    hide_cancellation_policy: 'Cuddio Polisi Canslo',
    departure: 'Ymadawiad',
    price: 'Pris',
    difficulty: 'Anhawster',
    duration: 'Hyd',
    starting_time: 'Amser cychwyn',
    about: 'Ynghylch',
    book_now: 'Archebu nawr',
    book: 'Archebu',
    buy_as_gift: 'prynu fel anrheg',
    from: 'Pris o',
    your_booking_reference_is: 'eich cyfeirnod archebu yw',
    booking_details_in_email: 'byddwch yn derbyn e-bost gyda gwybodaeth pellach yn fuan',
    see_more_activities: 'Gweld mwy o weithgareddau',
    your_cart: 'Eich basged',
    in_your_cart: 'Yn eich basged',
    when_are_you_going: 'Dewiswch ddyddiad ac amser',
    how_many_are_going: "Faint sy'n mynd?",
    contact_details: 'Manylion cyswllt',
    traveler: 'Teithiwr',
    extras: 'Ychwanegion',
    please_select: 'Dewiswch os gwelwch yn dda',
    no_items_in_cart: 'Does dim eitemau yn eich basged siopa',
    payment: 'Talu',
    receipt: 'Derbynneb',
    do_you_have_any_comments_or_special_needs:
        'Oes gennych unrhyw sylwadau neu anghenion arbennig?',
    i_have_read_and_accepted_the: 'Rwyf wedi darllen a derbyn y',
    privacy_policy: 'Polisi preifatrwydd',
    terms_and_conditions: 'Telerau ac amodau',
    must_accept_privacy_policy: 'Rhaid i chi dderbyn y Polisi Preifatrwydd i barhau',
    must_accept_terms_and_conditions: 'Rhaid i chi dderbyn y Telerau ac Amodau i barhau',
    first_name: 'Enw cyntaf',
    last_name: 'Cyfenw',
    phone_number: 'Rhif ffôn',
    dial_code: 'Cod ffonio',
    email: 'E-bost',
    is_required: 'yn ofynnol',
    please_register: 'Cofrestrwch os gwelwch yn dda',
    main_contact: 'Prif gyswllt',
    additional_information: 'Gwybodaeth ychwanegol',
    remove_cart_item: 'Dileu eitem basged',
    excl: 'heb.',
    vat: 'TAW',
    total: 'Cyfanswm',
    payNow: 'Talu nawr',
    payLater: "Talu'n hwyrach",
    only_deposit_amount_to_pay_now: {
        template: "Dim ond <NAME> fel blaendal i'w dalu nawr.",
    } as any,
    next: 'Nesaf',
    go_and_pay: 'Ewch a thalu',
    confirm_booking: 'Cadarnhau archeb',
    no_payment_required: 'Nid oes angen taliad',
    print: 'Argraffu',
    close: 'Cau',
    checkout: 'Talu',
    summary: 'Crynodeb',
    cancel: 'Canslo',
    save: 'Cadw',
    select_time: 'Dewis amser',
    selected_time: 'Amser a ddewiswyd',
    time: 'Amser',
    go_back: 'Mynd yn ôl',
    thank_you_for_booking_with_us: 'Diolch am archebu gyda ni!',
    please_fill_in_all_required_information:
        'Llenwch yr holl wybodaeth angenrheidiol os gwelwch yn dda',
    error_occurred_when_creating_reservation: "Digwyddodd gwall wrth greu'r archebiad",
    error_occurred_when_creating_giftcard: "Digwyddodd gwall wrth greu'r cerdyn anrheg",
    couldnt_apply_promocode_is_the_code_correct:
        "Methu cymhwyso'r cod hyrwyddo. Ydy'r cod yn gywir?",
    choose_a_country: 'Dewiswch wlad',
    select_date: 'Dewis dyddiad',
    select_travelers: 'Dewis teithwyr',
    hourShort: 'a',
    dayShort: 'd',
    minuteShort: 'm',
    years: 'blynyddoedd',
    age: 'Oedran',
    more_information: 'Mwy o wybodaeth',
    same_as_main_contact: "Yr un â'r prif gyswllt",
    easy: 'Hawdd',
    medium: 'Canolig',
    hard: 'Anodd',
    please_select_date: 'Dewiswch ddyddiad os gwelwch yn dda',
    please_select_date_and_time: 'Dewiswch ddyddiad ac amser os gwelwch yn dda',
    name: 'Enw',
    comment: 'Sylw',
    submit_request: 'Cyflwyno cais',
    any_special_requests_etc: 'Unrhyw geisiadau arbennig, alergeddau bwyd...?',
    request_tour_comment: 'Disgrifiwch eich cais',
    thank_you_for_your_request:
        'Diolch am eich cais, byddwn yn dod yn ôl atoch gyda chyflymder mellten.',
    got_it: 'Deall!',
    continue_shopping: 'Parhau i siopa',
    continue_travelers: 'Teithwyr',
    please_provide_your_name: 'Darparwch enw os gwelwch yn dda',
    please_provide_your_email: 'Darparwch e-bost dilys os gwelwch yn dda',
    please_provide_a_description: 'Darparwch ddisgrifiad os gwelwch yn dda',
    an_error_occurred_when_submitting_your_request:
        'Digwyddodd gwall wrth gyflwyno eich cais. Rhowch gynnig arall arni yn hwyrach.',
    private_tour: 'Taith breifat',
    read_more_and_book: 'Darllen mwy ac archebu',
    read_more: 'Darllen mwy',
    prices_from: 'Prisiau o',
    about_the_trip: 'Ynghylch y daith',
    prices: 'Prisiau',
    whats_included: "Beth sydd wedi'i gynnwys",
    any: 'Unrhyw',
    duration_up_to_1_hour: 'Hyd at 1 awr',
    duration_1_2_hours: '1 - 2 awr',
    duration_2_6_hours: '2 - 6 awr',
    duration_6_12_hours: '6 - 12 awr',
    duration_12_24_hours: '12 - 24 awr',
    duration_1_2_days: '1 - 2 diwrnod',
    duration_more_than_2_days: 'Mwy na 2 ddiwrnod',
    find_activities: 'Dod o hyd i weithgareddau',
    ok: 'Iawn',
    clear: 'Clirio',
    filterActivities: 'Hidlo gweithgareddau',
    hideFilters: 'Cuddio hidlwyr',
    shopMore: 'Siopa mwy',
    noSearchResults:
        "Mae'n ddrwg gennym, ni wnaethom ddod o hyd i unrhyw weithgareddau ar gael sy'n cyfateb i'ch chwiliad.",
    update: 'Diweddaru',
    select_date_to_view_timeslots: 'Dewiswch ddyddiad i weld slotiau amser ar gael',
    your_reservation_timed_out: 'Mae eich archebiad wedi dod i ben. Rhowch gynnig arall arni.',
    aria_calendar_input_field_label: 'Mewnbwn calendr. Pwyswch Enter i agor.',
    aria_book_now_button: "Agor ffenestr ar gyfer archebu'r gweithgaredd hwn",
    aria_next_image: 'Delwedd nesaf',
    aria_previous_image: 'Delwedd flaenorol',
    aria_open_booking_widget: 'Agor ffenestr archebu',
    aria_close_booking_widget: 'Cau ffenestr archebu',
    aria_go_to_home: 'Ewch i hafan',
    aria_checkout_steps: 'Camau talu',
    aria_order_summary: 'Crynodeb archeb',
    expanded: 'ehangu',
    collapsed: 'cydwasgu',
    aria_open_request_tour_widget: 'Agor ffenestr cais taith',
    aria_close_request_tour_widget: 'Cau ffenestr cais taith',
    aria_open_find_activity: 'Agor dod o hyd i weithgaredd',
    aria_close_find_activity: 'Cau dod o hyd i weithgaredd',
    aria_show_giftcard_input: 'Dangos maes cerdyn anrheg',
    aria_hide_giftcard_input: 'Cuddio maes cerdyn anrheg',
    fill_giftcard_code: 'Rhowch god cerdyn anrheg',
    aria_show_promocode_input: 'Dangos maes cod hyrwyddo',
    aria_hide_promocode_input: 'Cuddio maes cod hyrwyddo',
    aria_price_to_pay_summary: "Crynodeb o bris i'w dalu",
    vat_breakdown: 'Dadansoddiad TAW',
    fill_promocode: 'Rhowch god hyrwyddo',
    request_tour: 'cais taith',
    giftcard_message: 'neges',
    giftcard_message_label: "neges bersonol i'r derbynnydd (dewisol)",
    recipient_details: 'manylion derbynnydd',
    gift_card: 'cerdyn anrheg',
    value: 'gwerth',
    create: 'creu',
    create_your_gift: 'creu eich cerdyn anrheg',
    your_giftcard_reference_is: 'eich cyfeirnod yw',
    giftcard_voucher_and_receipt:
        "rydym wedi anfon taleb anrheg barod i'w argraffu ynghyd â derbynneb atoch at:",
    giftcard_voucher: 'rydym wedi anfon y taleb anrheg at:',
    giftcard_and_receipt: 'a derbynneb atoch chi at:',
    thank_you_for_your_purchase: 'diolch am eich pryniant!',
    valid_until: 'yn ddilys tan',
    print_receipt: 'argraffu derbynneb',
    select_gift_type: 'dewis math o anrheg',
    please_select_gift_type: 'dewiswch fath o anrheg os gwelwch yn dda',
    select_gift_print_description:
        'derbyn cerdyn anrheg PDF y gellir ei argraffu yn eich blwch derbyn',
    select_gift_email_description:
        'anfon cerdyn anrheg trwy e-bost yn uniongyrchol at y derbynnydd',
    enter_giftcard_code: 'Rhowch god cerdyn anrheg',
    enter_promo_code: 'Rhowch god hyrwyddo',
    apply: 'cymhwyso',
    giftcard_code_error: 'cod cerdyn anrheg ddim yn ddilys',
    remaining_value: "gwerth sy'n weddill",
    giftcard_code_not_found: "methu dod o hyd i gerdyn anrheg gyda'r cod:",
    giftcard_zero_balance: "mae'r cerdyn anrheg eisoes wedi'i wario",
    giftcard_is_expired: "mae'r cerdyn anrheg wedi dod i ben",
    purchased_giftcard: {
        self: "cerdyn anrheg y gellir ei argraffu wedi'i anfon atoch chi",
        recipient: "cerdyn anrheg y gellir ei argraffu wedi'i anfon at y derbynnydd",
    },
    contact_information: {
        short: 'gwybodaeth gyswllt',
        long: 'gwybodaeth gyswllt',
    },
    minutes: {
        singular: 'mun',
        plural: 'mun',
        long: 'munud',
    },
    hours: {
        singular: 'awr',
        plural: 'oriau',
    },
    days: {
        singular: 'diwrnod',
        plural: 'diwrnodau',
    },
    children: {
        singular: 'plentyn',
        plural: 'plant',
    },
    adult: {
        singular: 'oedolyn',
        plural: 'oedolion',
    },
    card: {
        singular: 'cerdyn',
        plural: 'cardiau',
    },
    too_few_travelers: 'Rhy ychydig o gyfranogwyr',
    too_few_travelers_quantity: {
        template: 'Isafswm <COUNT:tocyn:tocynnau> yn ofynnol y diwrnod hwn',
    } as any,
    number_of_travelers_exceeded: {
        template: 'Uchafswm <COUNT:tocyn:tocynnau> ar gael y diwrnod hwn',
    } as any,
    booking_is_closed: {
        template: 'Mae archebu ar gyfer <NAME> bellach wedi cau',
    } as any,
    rooms: {
        singular: 'ystafell',
        plural: 'ystafelloedd',
    },
    person: {
        singular: 'person',
        plural: 'personau',
    },
    select_room: 'dewis ystafell',
    change_room: 'newid ystafell',
    less_than: 'llai na',
    year: {
        singular: 'blwyddyn',
        plural: 'blynyddoedd',
    },
    select_age: 'dewis oedran',
    done: 'gorffen',
    number_of_rooms: 'nifer yr ystafelloedd',
    select_bed: 'dewis gwely',
    room_info: 'gwybodaeth ystafell',
    price_one_night_one_guest: {
        template: 'pris ar gyfer <COUNT:noson:nosweithiau>, <COUNT:gwestai:gwesteion>',
    } as any,
    one_night_one_guest: {
        template: '<COUNT:noson:nosweithiau>, <COUNT:gwestai:gwesteion>',
    } as any,
    price_nights: {
        template: 'pris ar gyfer <COUNT:noson:nosweithiau>',
    } as any,
    night: {
        singular: 'noson',
        plural: 'nosweithiau',
    },
    select_room_for_total_price: 'dewiswch ystafelloedd i gael cyfanswm y pris',
    find_rooms: 'dod o hyd i ystafelloedd',
    check_in_check_out: 'Mewngofnodi ac Allgofnodi',
    guest_and_rooms: 'Gwesteion ac ystafelloedd',
    no_accommodations_found:
        "Mae'n ddrwg gennym, ond ni allwn ddod o hyd i unrhyw ystafelloedd sy'n cyfateb i'ch meini prawf chwilio. A ydych wedi ystyried addasu eich paramedrau chwilio i ddod o hyd i ystafelloedd ar gael?",
    facilities_included: "Cyfleusterau wedi'u cynnwys",
    price_per_night: 'Pris y noson',
    season: 'Tymor',

    has_airconditioning: 'Aerdymheru',
    has_balcony: 'Balconi',
    has_bicycles: 'Beiciau',
    has_boat: 'Cwch',
    has_coffee_maker: 'Peiriant coffi',
    has_dishwasher: 'Peiriant golchi llestri',
    has_dryer: 'Sychwyr',
    has_fireplace: 'Lle tân',
    has_garage: 'Garej',
    has_garden_furniture: 'Dodrefn gardd',
    has_grill: 'Gril',
    has_kitchen: 'Cegin',
    has_minibar: 'Bar bach',
    has_mooring_space: 'Lle angori',
    has_pool: 'Pwll',
    has_roomservice: 'Gwasanaeth Ystafell',
    has_sauna: 'Sawna',
    has_tv: 'Teledu',
    has_washing_machine: 'Peiriant Golchi',
    has_wifi: 'WiFi',
    is_breakfast_included: 'Brecwast',
    is_cancellation_included: 'Posibilrwydd i ganslo',
    is_pets_allowed: 'Anifeiliaid anwes yn cael eu caniatáu',
    is_smoking_allowed: 'Ysmygu yn cael ei ganiatáu',
    is_towels_and_bedlines_included: 'Tyweli a dillad gwely',
    is_wheelchair_accessible: 'Hygyrch i gadair olwyn',
    wifi: 'WiFi',
    breakfast: 'Brecwast',
    accessible: 'Hygyrch',
    pets: 'Anifeiliaid anwes',
    kitchen: 'Cegin',
    smoking: 'Ysmygu',
    unknown: 'Anhysbys',
    accommodation_cancellation_policy: '',
    accommodations: 'Llety',
    activities: 'Gweithgareddau',
    address: 'cyfeiriad',
    city: 'dinas',
    post_code: 'cod post',
    to: 'i',
    date_range_start: 'dechrau',
    date_range_end: 'diwedd',
    flag_of: 'baner',
    monday: 'Dydd Llun',
    tuesday: 'Dydd Mawrth',
    wednesday: 'Dydd Mercher',
    thursday: 'Dydd Iau',
    friday: 'Dydd Gwener',
    saturday: 'Dydd Sadwrn',
    sunday: 'Dydd Sul',
    today: 'heddiw',
    tomorrow: 'yfory',
    january: 'Ionawr',
    february: 'Chwefror',
    march: 'Mawrth',
    april: 'Ebrill',
    may: 'Mai',
    june: 'Mehefin',
    july: 'Gorffennaf',
    august: 'Awst',
    september: 'Medi',
    october: 'Hydref',
    november: 'Tachwedd',
    december: 'Rhagfyr',
    few_left: 'ychydig ar ôl',
    tickets_left: {
        template: '<COUNT:tocyn:tocynnau> ar ôl',
    } as any,
    available: 'ar gael',
    sold_out: 'wedi gwerthu allan',
    upcoming_tours_title: 'Teithiau Sydd i Ddod',
    unavailable: 'Ddim ar gael',
    notes_regarding_your_stay: 'Nodiadau ynghylch eich arhosiad',
    notes_for_accommodation_name_with_guests: {
        template: 'Nodiadau ar gyfer <NAME> gyda <COUNT:gwestai:gwesteion>',
    } as any,
    select_price_type: 'Dewis math o bris',
    tour_option: 'Dewis taith',
    finding_available_rooms: 'Dod o hyd i ystafelloedd ar gael',
    loading_availability: 'Llwytho argaeledd...',
    total_price: 'Cyfanswm y pris',
    of: 'o',
    select_dates: 'Dewis dyddiadau',
    please_select_price_type: 'Dewiswch fath o bris os gwelwch yn dda',
    a_minimum_of_participants_is_required_to_book_this_product:
        "Mae angen isafswm nifer o gyfranogwyr i archebu'r cynnyrch hwn.",
    a_minimum_of_x_participants_is_required_to_book_this_product: {
        template: "Mae angen isafswm o <COUNT> cyfranogwr i archebu'r cynnyrch hwn",
    } as any,
    aBookingConfirmationWillBeSentToYourEmailAddressAsSoonAsWeHaveProcessedYourOrder:
        'Bydd cadarnhad archebu yn cael ei anfon at eich cyfeiriad e-bost cyn gynted ag y byddwn wedi prosesu eich archeb.',
    aConfirmationWillBeSentToYourEmailAddressAsSoonAsWeHaveProcessedYourOrder:
        'Bydd cadarnhad yn cael ei anfon at eich cyfeiriad e-bost cyn gynted ag y byddwn wedi prosesu eich archeb.',
    add: 'Ychwanegu',
    amount: 'Swm',
    areYouAMemberOrHaveValueCard: "Ydych chi'n aelod, neu oes gennych gerdyn gwerth?",
    areYouSureYouWantToCancelYourBooking:
        "Ydych chi'n siŵr eich bod eisiau canslo'r archebiad hwn?",
    areYouSureYouWantToCancelYourMembership:
        "Ydych chi'n siŵr eich bod eisiau canslo eich aelodaeth?",
    automaticallyRenewed: "Wedi'i adnewyddu'n awtomatig",
    at: 'Yn',
    backToWebsite: "Yn ôl i'r wefan",
    belayCertification: 'Tystysgrif sicrhau',
    belayCertificationConsent: 'Mae gen i dystysgrif sicrhau',
    buyMembership: 'Prynu aelodaeth',
    buyNow: 'Prynu nawr',
    cancelled: "Wedi'i ganslo",
    canBeCancelledFrom: 'Gellir ei ganslo o',
    choose_payment_method: 'Dewiswch ddull talu',
    bookNow: 'Prynu nawr',
    bookTimeslot: 'Prynu tocynnau',
    cancellation: 'Canslo',
    choose: 'Dewis',
    chooseACountry: 'Dewiswch wlad',
    chooseCreditsType: 'Dewiswch fath o gredydau',
    chooseDateAndTime: 'Dewiswch ddyddiad ac amser',
    chooseNumberOfCredits: 'Dewiswch nifer y credydau',
    chooseStartDate: 'Dewiswch ddyddiad cychwyn',
    chooseType: 'Dewiswch fath',
    ticketCode: 'Cyfeirnod archeb',
    completed: "Wedi'i gwblhau",
    consents: 'Caniatadau',
    contact: 'Cyswllt',
    contactByEmail: 'Cysylltu trwy E-bost',
    contactBySms: 'Cysylltu trwy SMS',
    couldntApplyGiftcardIsTheCodeCorrect: "Methu cymhwyso'r cerdyn anrheg. Ydy'r cod yn gywir?",
    couldntApplyPromocodeIsTheCodeCorrect: "Methu cymhwyso'r cod hyrwyddo. Ydy'r cod yn gywir?",
    promocodeIsNotCompatibleWithCart:
        "Nid yw'r cod hyrwyddo hwn yn gydnaws â'ch cynhyrchion a ddewiswyd.",
    couldntGetCompanyInformation: 'Methu cael gwybodaeth y cwmni',
    couldntGetPaymentPlan: "Methu cael cynllun talu. Rhowch gynnig ar adnewyddu'r dudalen we.",
    couldntGetPaymentPlanUsingPreviousPlan:
        "Methu cael cynllun talu, yn defnyddio'r cynllun blaenorol",
    couldntGetValueCards: 'Methu cael cardiau gwerth',
    couldntGetValueCardProducts: 'Methu cael cynhyrchion cerdyn gwerth',
    couldntGetProductPleaseTryAgain: 'Methu cael cynnyrch, rhowch gynnig arall arni',
    couldntOpenBookingCheckoutNotAllBookingInformationHasBeenSet:
        "Methu agor talu archebu, nid yw'r holl wybodaeth archebu angenrheidiol wedi'i nodi.",
    couldntOpenProfilePleaseSignInFirst:
        'Methu agor proffil, mewngofnodwch yn gyntaf os gwelwch yn dda.',
    couldntOpenValueCardCheckoutNotAllValueCardInformationHasBeenSet:
        "Methu agor talu cerdyn gwerth, nid yw'r holl wybodaeth cerdyn gwerth angenrheidiol wedi'i nodi.",
    country: 'Gwlad',
    createAccount: 'Creu cyfrif',
    credit: {
        singular: 'Credyd',
        plural: 'Credydau',
    },
    credits: 'Credydau',
    creditsLeft: 'Credydau ar ôl',
    creditDiscount: 'Disgownt credyd',
    discount: 'Disgownt',
    free: 'Am ddim',
    date: 'Dyddiad',
    delete: 'Dileu',
    doYouHaveAnAccount: 'Oes gennych gyfrif?',
    doYouHaveValueCards: 'Oes gennych gyfrif, neu unrhyw gardiau gwerth?',
    doYouHaveBrattkort: 'Oes gennych Brattkort neu dystysgrif sicrhau?',
    doYouHaveClimbingCertification: 'Oes gennych dystysgrif dringo?',
    edit: 'Golygu',
    editTimeslot: 'Golygu slot amser',
    failed: 'Wedi methu',
    firstName: 'Enw cyntaf',
    giftcard: 'Cerdyn anrheg',
    goToMyPage: 'Mynd i fy nhudalen',
    ifYouWantToDeleteYourProfile: 'Os ydych eisiau dileu eich proffil',
    youCanPurchaseBookingsFromTheShopOnThisWebsite:
        "Gallwch brynu tocynnau o'r siop ar y wefan hon.",
    yourOrderReferenceIs: 'Eich cyfeirnod archeb yw',
    iHaveReadAndAccepted: 'Rwyf wedi darllen a derbyn y',
    lastName: 'Cyfenw',
    postalLocation: 'Lleoliad',
    location: 'Lleoliad',
    loggedInAs: 'Wedi mewngofnodi fel',
    login: 'Mewngofnodi',
    logout: 'Allgofnodi',
    membershipCard: 'Aelodaeth',
    membershipNumber: 'Rhif aelodaeth',
    membershipSlashCredits: 'Aelodaeth / Credydau',
    myAddress: 'Fy nghyfeiriad',
    myPage: 'Fy nhudalen',
    myProfile: 'Fy mhroffil',
    nextCreateAccount: 'Nesaf: Creu cyfrif',
    no: 'Na',
    noneSelected: "Dim un wedi'i ddewis",
    noSelectedDate: "Dim dyddiad wedi'i ddewis",
    notAllFieldsHaveBeenFilledPleaseFillAllFields:
        "Nid yw'r holl feysydd wedi'u llenwi, darparwch yr holl feysydd os gwelwch yn dda.",
    noUserInfoFound: "Dim gwybodaeth defnyddiwr wedi'i darganfod.",
    numberOfPersons: {
        singular: 'person',
        plural: 'personau',
        template: '<COUNT:person:personau>',
    } as any,
    pay: 'Talu',
    payWithCreditCard: 'Talu gyda cherdyn credyd',
    phoneNumber: 'Rhif ffôn',
    pleaseChoose: 'Dewiswch os gwelwch yn dda',
    pleaseContact: 'Cysylltwch os gwelwch yn dda',
    pleaseFillOutUserInfoInProfile:
        'Llenwch wybodaeth defnyddiwr yn eich proffil os gwelwch yn dda.',
    pleaseLogInToBook: "Mewngofnodwch i brynu gyda'r rhain os gwelwch yn dda",
    pleaseLogInToPurchase:
        'Mewngofnodwch os gwelwch yn dda a byddwn yn llenwi eich gwybodaeth gyswllt i chi',
    pleaseProvideAllValueCardInformation:
        'Darparwch yr holl wybodaeth cerdyn gwerth os gwelwch yn dda',
    pleaseProvideProperBookingInformation: 'Darparwch wybodaeth ddilys os gwelwch yn dda',
    pleaseRegister: 'Cofrestrwch os gwelwch yn dda',
    postalCodeAndLocation: 'Cod post / lleoliad',
    prefix: 'Rhagddodiad',
    privacyPolicy: 'Polisi preifatrwydd',
    problemLoadingData: 'Gwall wrth lwytho data',
    processing: 'Prosesu',
    purchaseValueCard: 'Prynu cerdyn gwerth',
    readMoreAbout: 'Darllen mwy am ein',
    readMoreAndBook: 'Darllen mwy ac archebu',
    readMoreAndBuy: 'Darllen mwy a phrynu',
    refillCredits: 'Ail-lenwi credydau',
    returnToWebsite: "Dychwelyd i'r wefan",
    scanTicket: 'Sganio tocyn',
    signUp: 'Cofrestru',
    subtract: 'Tynnu',
    shoesAndHarnessAlwaysIncluded: "Esgidiau a harnais bob amser wedi'u cynnwys.",
    shoesAndHarnessNotIncluded: 'Esgidiau a harnais heb eu cynnwys.',
    somethingWentWrongUpdatingUserInfo:
        "Aeth rhywbeth o'i le wrth ddiweddaru gwybodaeth defnyddiwr.",
    termsOfUse: {
        template: 'Telerau defnydd ar gyfer <NAME>',
    } as any,
    upcomingBookings: 'Archebion sydd i ddod',
    updateAddress: 'Diweddaru cyfeiriad',
    terminate: 'Terfynu',
    thankYouForBookingWithUs: 'Diolch am archebu gyda ni.',
    thePrivacyPolicy: 'Polisi Preifatrwydd',
    thankYouForShoppingWithUs: 'Diolch am siopa gyda ni.',
    thisGiftcardIsEmpty: "Mae'r cerdyn anrheg hwn yn wag.",
    tHours: 'oriau',
    totalCredits: 'Cyfanswm credydau',
    totalNOK: 'Cyfanswm NOK',
    updateBooking: 'Diweddaru archebiad',
    updateProfile: 'Diweddaru proffil',
    useGiftcard: 'Defnyddio cerdyn anrheg',
    useGiftcardOrPromocode: 'Defnyddio cerdyn anrheg / cod hyrwyddo',
    validationNotANumber: 'Rhaid bod yn rhif',
    validationMaxNumber: {
        template: 'Dim rhifau uwchlaw <NUM>',
    } as any,
    validationMinNumber: {
        template: 'Dim rhifau islaw <NUM>',
    } as any,
    validForThePeriod: 'Yn ddilys ar gyfer y cyfnod',
    validUntil: 'Yn ddilys tan',
    validFrom: 'Yn ddilys o',
    valueCard: 'Cerdyn gwerth',
    visitors: 'Ymwelwyr',
    withoutVat: 'Heb TAW',
    yes: 'Ie',
    youDontHaveAnyUpcomingBookings: 'Does gennych ddim archebion sydd i ddod.',
    youDontHaveAnyValueCards: 'Does gennych ddim cardiau gwerth',
    youDontHaveAValidMembershipDoYouWantToPurchaseIt:
        'Does gennych ddim aelodaeth ddilys, ydych chi eisiau prynu un?',
    youMustSpecifyAValueCard: 'Rhaid i chi nodi cerdyn gwerth dilys.',
    yourReservationTimedOut: 'Mae eich archebiad wedi dod i ben.',
    zipcode: 'Cod post',
    payByMembershipCard: 'Talu gyda cherdyn aelodaeth',
    payWith: 'Talu gyda',
    deleteMyProfile: 'Dileu fy mhroffil',
    areYouSureYouWantToDeleteYourProfile: "Ydych chi'n siŵr eich bod eisiau dileu eich proffil?",
    deleteYourProfileInformation:
        'Rydych ar fin dileu a datgysylltu gwybodaeth eich proffil o unrhyw archebion a chynhyrchion a brynwyd. Ni ellir dadwneud y weithred hon. Efallai y bydd rhywfaint o wybodaeth yn cael ei storio am resymau cyfreithiol.',
    choosePaymentOtherMethods: 'Dewiswch ddulliau talu eraill',
    dontUseMembershipCardForThisBooking:
        'Peidiwch â defnyddio cerdyn aelodaeth ar gyfer yr archebiad hwn',
    nameNotProvided: "Nid yw enw wedi'i ddarparu",
    phoneNumberNotProvided: "Nid yw rhif ffôn wedi'i ddarparu",
    emailNotProvided: "Nid yw e-bost wedi'i ddarparu",
    addressNotProvided: "Nid yw cyfeiriad wedi'i ddarparu",
    promocode: 'Cod hyrwyddo',
    show_usage_terms: 'Dangos Telerau Defnydd',
    hide_usage_terms: 'Cuddio Telerau Defnydd',
    about_the_product: 'ynghylch y cynnyrch',
    successful: 'Llwyddiannus',
    selectProduct: 'Dewis Cynnyrch',
    withCreditCard: 'Gyda cherdyn credyd',
    paymentMethod: 'Dull Talu',
    noAvailableTimeslots: 'Dim slotiau amser ar gael',
    orderReference: 'Cyfeirnod Archeb',
    iWishToRecieveNewsletters: 'Hoffwn dderbyn cylchlythyrau',
    mySite: 'Fy Safle',
    pleaseConfirm: {
        template: 'Cadarnhewch "<NAME>" os gwelwch yn dda',
    } as any,
    pleaseProvideNumberOfParticipants: 'Darparwch nifer y cyfranogwyr os gwelwch yn dda',
    pleaseSelectTheDateAndTimeOfYourBooking:
        'Dewiswch ddyddiad ac amser eich archebiad os gwelwch yn dda',
    pleaseSelectNumberOfCredits: 'Dewiswch nifer y credydau os gwelwch yn dda',
    pleaseSelectTypeOfCreditcard: 'Dewiswch fath o gerdyn credyd os gwelwch yn dda',
    pleaseSelectAStartDate: 'Dewiswch ddyddiad cychwyn os gwelwch yn dda',
    pleaseSelectAMembershipType: 'Dewiswch fath o aelodaeth os gwelwch yn dda',
    contactCustomerServiceToDeleteYourProfile:
        'Cysylltwch â gwasanaeth cwsmeriaid i ddileu eich proffil',
    inclInMembership: "Wedi'i gynnwys yn yr aelodaeth",
    maxAmount: 'Uchafswm',
    checkIn: 'Mewngofnodi',
    checkOut: 'Allgofnodi',

    anErrorOccurredDuringPayment: 'Digwyddodd gwall yn ystod y taliad',
    anErrorOccurredPleaseTryAgainByReloadingThePageErrorMessage:
        "Digwyddodd gwall, rhowch gynnig arall arni trwy ail-lwytho'r dudalen. Neges gwall",
    share: 'Rhannu',
    copyLink: 'Copïo dolen',
    howDoYouWantToShare: 'Sut ydych chi eisiau rhannu?',

    shoppingCart: 'Basged siopa',
    heresMyShoppingCart: 'Dyma fy masged siopa',
    thereIsNotEnoughCapacityForTheItemsInThisCart:
        'Does dim digon o gapasiti ar gyfer yr eitemau yn y fasged hon',

    full: 'Llawn',
    no_available_capacity_for_this_tour: 'Dim capasiti ar gael ar gyfer y daith hon',
    no_availability_for_selected_rooms_and_guests:
        "Nid yw'r nifer hwn o westeion ar gael ar gyfer y dyddiadau hyn — rhowch gynnig ar lai o westeion neu ddyddiadau gwahanol.",
    one_or_more_activities_or_accommodations_dont_have_enough_capacity:
        'Nid oes gan un neu fwy o weithgareddau ddigon o gapasiti',

    pick_a_date: 'Dewiswch ddyddiad',
    package: 'Pecyn',
    packages: 'Pecynnau',
    customize_activities: 'Addasu gweithgareddau',
    check_in_at: 'Mewngofnodi am',
    activity_starts_at: "Mae'r gweithgaredd yn dechrau am",
    other_times_are_available: 'Mae amseroedd eraill ar gael',
    press_to_select_other_options: 'Pwyswch i ddewis opsiynau eraill',
    unavailableForSelectedTime: 'Ddim ar gael ar yr amser a ddewiswyd',
    order_status_awaiting_payment: 'Prosesu taliad',
    order_status_payment_failed: 'taliad wedi methu',
    awaiting_payment_info: 'Prosesu taliad... fel arfer ddim yn cymryd mwy na ychydig funudau.',
    cancel_membership: 'Canslo aelodaeth',
    update_subscription_payment_details: 'Diweddaru manylion talu',
    payment_failed_info:
        "Mae'n ymddangos bod problem gyda'ch taliad. Gallech roi cynnig ar ddiweddaru'r manylion talu.",
    retry_subscription_payment: 'Rhoi cynnig arall ar dalu nawr',

    entrance: 'Mynedfa',
    related_products: 'Cynhyrchion perthynol',
    some_tickets_are_unavailable_the_selected_day:
        'Mae rhai tocynnau ddim ar gael y diwrnod a ddewiswyd',
    company: 'Cwmni',
    customer_type: 'Math o gwsmer',
    company_name: 'Enw cwmni',
    org_number: 'Rhif sefydliad',
    pay_with_invoice: 'Talu gydag anfoneb',
    continueWithRebooking: 'Parhau gydag ail-archebu',
    searchAndBookAccommodations: 'Chwilio ac archebu llety',
    selectNumberOfGuests: 'Dewis nifer y gwesteion',
    checkAvailability: 'Gwirio argaeledd',
    updateAvailability: 'Diweddaru argaeledd',
    you_will_have_to_switch_rooms_during_your_stay:
        "Bydd rhaid i chi newid ystafelloedd yn ystod eich arhosiad. Cysylltwch â ni i barhau gyda'r archebiad.",
    selected: "Wedi'i ddewis",
    remove: 'Dileu',
    empty_cart: 'Gwagio basged',
    aria_increase: 'Cynyddu',
    aria_decrease: 'Lleihau',
    promo_code_not_supported_for_gift_cards:
        "Nid yw'r cod hyrwyddo yn cael ei gefnogi ar gyfer cardiau anrheg",
    select_products: 'Dewis cynhyrchion',
    change_selected_products: 'Newid cynhyrchion a ddewiswyd',
    see_available_tickets: 'Gweld tocynnau sydd ar gael',
    waiting_list: 'Rhestr Aros',
    join_waiting_list: 'Ymuno â Rhestr Aros',
    no_waiting_list_items_found: "Dim eitemau rhestr aros wedi'u darganfod yn y fasged",
    waiting_list_notification_message: 'Byddwn yn eich hysbysu pan fydd lleoedd yn dod ar gael',

    waiting_list_what_happens_next: "Beth sy'n digwydd nesaf?",
    waiting_list_next_steps:
        'Byddwn yn monitro argaeledd ar gyfer eich eitemau a ddewiswyd|Byddwch yn derbyn e-bost pan fydd lleoedd yn agor|Dilynwch y ddolen yn yr e-bost i gwblhau eich archebiad',
    product_required_for_function: {
        template: 'Mae angen cynnyrch ar gyfer <NAME>, a dderbyniwyd: <NAME>',
    } as any,
    giftcard_cannot_be_used_with_deposit_payment:
        'Ni ellir defnyddio cerdyn anrheg gyda thaliad blaendal',
};

export default translations;
